/*
 * @Author: fengxiaojing
 * @LastEditTime: 2022-07-22 20:02:18
 * @Description: 剖切相关
 * @LastEditors: Please set LastEditors
 */
let isClipEdtingConnection = false
import { Message } from 'element-ui'
let axisObjs = []
let clipObj = {}
let publicPlayer = null
/**
 * @description: 创建剖切盒子
 * @param {*}
 * @return {*}
 */
const createCilpBox = async (player, playerId) => {
  const selectInfo = await PlayerUtils.call(player.Native.ModelTree.getSelectedItem)
  // 储存当前激活的节点item
  let currentItem = 0
  if (!_.isEmpty(selectInfo)) {
    currentItem = selectInfo.item
  } else {
    // 未选择模型时，获取整个模型的item
    const modelInfo = await PlayerUtils.call(player.Native.Model.getInfo, playerId)
    currentItem = modelInfo.treeItem
  }
  player.Native.Camera.moveToItem(currentItem, 2)
  let itemAabbData = await PlayerUtils.call(player.Native.ModelTree.calcItemAabbData, currentItem)
  // 计算剖切的旋转矩阵
  await PlayerUtils.call(player.Native.ClipBox.setGisMatrix, clipObj, itemAabbData.localMatrix)
  player.Native.ClipBox.clipBoxInitByAabb(clipObj, itemAabbData.localAabb)
}
const createAxis = async (player, axisType) => {
  if (axisType === 1) {
    // 指定坐标轴位置
    player.Native.NodeEditor.setNode(clipObj)
    player.Native.NodeEditor.setEditType(1)
    player.Native.NodeEditor.setEditCoordinateSysType(2)
  }
  // 创建轴编辑对象
  if (axisType === 4) {
    for (let i = 0; i < 6; ++i) {
      // 创建轴对象  4.为单轴移动编辑轴
      axisObjs[i] = await PlayerUtils.call(player.Native.Axis.createEditAxis, axisType)
      const tmpPs = await PlayerUtils.call(player.Native.Axis.properties, axisObjs[i])
      // 轴的风格属性,0:箭头风格;1:圆锥风格
      tmpPs.style = 1
      const tmpTR = await PlayerUtils.call(player.Native.ClipBox.clipBoxPanelTRMatrix, clipObj, i)
      const d = Matrix4.decompose(tmpTR)
      tmpPs.position = d.position
      tmpPs.dir = Matrix4.multiplyDir(d.rotation, [0, 0, 1])
      player.Native.Axis.setProperties(axisObjs[i], tmpPs)
    }
  }
}

const updateAxis = async (player, axisType) => {
  if (axisType === 1) {
    // 指定坐标轴位置
    player.Native.NodeEditor.setNode(clipObj)
    player.Native.NodeEditor.setEditType(1)
    player.Native.NodeEditor.setEditCoordinateSysType(2)
  }
  // 创建轴编辑对象
  if (axisType === 4) {
    for (let i = 0; i < axisObjs.length; ++i) {
      const tmpPs = await PlayerUtils.call(player.Native.Axis.properties, axisObjs[i])
      // 轴的风格属性,0:箭头风格;1:圆锥风格
      tmpPs.style = 1
      const tmpTR = await PlayerUtils.call(player.Native.ClipBox.clipBoxPanelTRMatrix, clipObj, i)
      const d = Matrix4.decompose(tmpTR)
      tmpPs.position = d.position
      tmpPs.dir = Matrix4.multiplyDir(d.rotation, [0, 0, 1])
      player.Native.Axis.setProperties(axisObjs[i], tmpPs)
    }
  }
}

const onEditting = async (param) => {
  let index = -1
  for (let i = 0; i < axisObjs.length; ++i) {
    if (param.sender == axisObjs[i]) index = i
  }
  if (index < 0 || index > 5) return
  if (!clipObj) return

  // 移动面
  publicPlayer.Native.ClipBox.clipBoxMovePanel(clipObj, param.relativeOffset, index)

  // 编辑轴跟随移动
  for (let i = 0; i < axisObjs.length; ++i) {
    const tmpPs = await publicPlayer.Native.Axis.properties(axisObjs[i])
    tmpPs.style = 1
    const tmpTR = await publicPlayer.Native.ClipBox.clipBoxPanelTRMatrix(clipObj, i)
    const d = Matrix4.decompose(tmpTR)
    tmpPs.position = d.position
    tmpPs.dir = Matrix4.multiplyDir(d.rotation, [0, 0, 1])
    publicPlayer.Native.Axis.setProperties(axisObjs[i], tmpPs)
  }
}
/**
 * @description:
 * @param {player,setIsInside,setPartCilp,clipType, axisType}
 *                是否启用内剖切，是否启用局部剖切,剖切方式,轴样式
 * @return {*}
 */
async function setCilp(player, playerId, setIsInside, setPartCilp, clipType, axisType) {
  publicPlayer = player
  // 获取当前点选的对象
  const selectInfo = await PlayerUtils.call(player.Native.ModelTree.getSelectedItem)
  // 是否启用局部剖切
  if (setPartCilp) {
    let currentItem = ''
    if (_.isEmpty(selectInfo)) {
      // 未选择模型时，获取整个模型的item
      const modelInfo = await PlayerUtils.call(player.Native.Model.getInfo, playerId)
      currentItem = modelInfo.treeItem
    } else {
      currentItem = selectInfo.item
    }
    player.Native.ClipBox.setLocalEnabled(currentItem)
  } else {
    player.Native.ClipBox.setLocalDisabled()
  }
  // 创建剖切对象
  switch (clipType) {
    case 'box':
      // 盒子剖切
      clipObj = await PlayerUtils.call(player.Native.ClipBox.activeClipBox)
      // 创建剖切盒子
      await createCilpBox(player, playerId)
      break
    case 'singlePanel':
      // 单面剖切
      clipObj = await PlayerUtils.call(player.Native.ClipBox.activeClipPanel)
      break
    case 'doublePanel':
      // 双面剖切
      clipObj = await PlayerUtils.call(player.Native.ClipBox.activeClipTwoPanel)
      break
    case 'ThreePanel':
      // 三面剖切
      clipObj = await PlayerUtils.call(player.Native.ClipBox.activeClipThreePanel)
      let { eye: cameraEye } = await PlayerUtils.call(player.Native.Camera.currentParam)
      let anchorPosition = await PlayerUtils.call(player.Native.Camera.getAnchorPos)
      const modelInfo = await player.Native.Model.getInfo(playerId)
      // 获取模型在地球上的位置
      const nodePos = await PlayerUtils.call(player.Native.NodeProxy.nodeGisPos, modelInfo.nodePtr)
      if (!_.isEmpty(nodePos)) {
        // 获取当前位置的旋转矩阵
        const gisTransform = await PlayerUtils.call(
          player.Native.GisPlatform.makeGisTransform,
          nodePos
        )
        const gisTransformInv = Matrix4.inverse(gisTransform)
        // 计算出当前视角+锚点位置相对原点所做的旋转
        cameraEye = Matrix4.multiplyPos(gisTransformInv, cameraEye)
        anchorPosition = Matrix4.multiplyPos(gisTransformInv, anchorPosition)
        await PlayerUtils.call(player.Native.ClipBox.setGisMatrix, clipObj, gisTransform)
      }
      player.Native.ClipBox.clipThreePanelInitByPoints(clipObj, anchorPosition, cameraEye, [
        2,
        2,
        2,
      ])
      break
    default:
      break
  }
  // 启用剖切
  player.Native.ClipBox.setEnabled(true)
  // 是否启用内剖切
  player.Native.ClipBox.setIsInside(setIsInside)
  // 创建编辑轴
  await createAxis(player, axisType)
  player.Native.Axis.EventAxisEditting.connect(onEditting)
  isClipEdtingConnection = true
  return {
    clipObj,
    axisObjs,
  }
}
/**
 * @description: 取消剖切
 * @param {*}
 * @return {*}
 */
function cancelClip(player) {
  if (isClipEdtingConnection) {
    player.Native.Axis.EventAxisEditting.disconnect(onEditting)
    isClipEdtingConnection = false
  }
  player.Native.ClipBox.setEnabled(false)
  // 取消激活剖切对象
  player.Native.ClipBox.inactiveClipObject()
  player.Native.Axis.destroyAllEditAxis()
  player.Native.NodeEditor.setNode(0)
}

export { setCilp as cilpSetting, cancelClip, updateAxis }
